/**
 * Sidebar Module
 */

// import { menus } from './data.js';

import { menusAccessReport, menusCaats, menusCdds, menusDashboard, menusDocuments, menusEstimateCostOfForeignMarket, menusImmigrations, menusIncomes, menusInformationStatistic, menusMonitorTravel, menusSettings, menusSmartDatas, menusVos, menusWidgets, menusWorldOutbound } from './menus'

import { API_ENDPOINT_URL } from '@/config/api_config'
import instance from '@/helpers/axios';

const state = {
  menusSmartDatas,
  // menusMonitorTravel,
  menusDashboard,
  menusWidgets,
  menusCaats,
  menusCdds,
  menusIncomes,
  menusEstimateCostOfForeignMarket,
  menusSettings,
  menusDocuments,
  menusImmigrations,
  menusInformationStatistic,
  menusWorldOutbound,
  menusAccessReport,
  menusVos
  // permissions: localStorage.getItem("permissions")
}

const getters = {
  menus: state => {
    return [
      state.menusSmartDatas,
      // state.menusMonitorTravel,
      ...state.menusDashboard,
      state.menusImmigrations,
      state.menusCaats,
      state.menusCdds,
      state.menusIncomes,
      state.menusEstimateCostOfForeignMarket,
      state.menusVos,
      state.menusInformationStatistic,
      ...state.menusWorldOutbound,
      state.menusAccessReport,
      //state.menusWidgets,
      state.menusSettings
    ]
  },
  menusAD: state => {
    return [
      state.menusSmartDatas,
      // state.menusMonitorTravel,
      ...state.menusDashboard,
      state.menusImmigrations,
      state.menusCaats,
      state.menusCdds,
      state.menusIncomes,
      state.menusEstimateCostOfForeignMarket,
      state.menusVos,
      state.menusInformationStatistic,
      ...menusDocuments,
      ...state.menusWorldOutbound,
      state.menusAccessReport
      //state.menusWidgets
    ]
  },
}

const actions = {
  setActiveMenuGroup(context, payload) {
    context.commit('setActiveMenuGroupHandler', payload)
  },
  getWidgetMenu({commit, state, rootState}, payload) {
    instance.get(`${API_ENDPOINT_URL}widgettypes/allwidgets`)
      .then(response => response.data)
      .then((type) => {
        const user = JSON.parse(localStorage.getItem("user"))
        const types = type.map((type) => {
          const children = type.widgets.filter(
            function(widget) {
              if(user.rolename == 'admin'){
                return true
              }else{
                return this.includes(`view_widget_${widget.code}`);
              }
            },rootState.auth.permissions
          ).map((widget) => {
            
            return {
              title: widget.name,
              path: widget.url
            }
          })

          return {
            title: type.name,
            path: `/admin/widget/${type.slug}`,
            children: children
          }
        }).filter((type) => {
          return type.children.length > 0
        })
        commit('setWidgetMenu', types)
      })
  },
  setDashboardMenus({commit, rootState }, payload) {
    let user = JSON.parse(localStorage.getItem('user')) || null
    const dashboardWidgets = state.menusDashboard.map((dashboards) => {
      if(typeof dashboards.widgets !== "undefined"){
        const widgets = dashboards.widgets.filter((widget) => {
          if(user.rolename == 'admin' || user.type =='ad_auth'){
            return true
          }else{
            return rootState.auth.permissions.includes(`view_widget_${widget.code}`);
          }
        }).map((widget) => {
          return {
            code: widget.code,
            show: true
          }
        })

        return widgets
      }
    }).map((dashboard, index) => {
      if(typeof dashboard === "undefined" || dashboard.length === 0){
        return index
      }
    }).filter((dashboard) => {
      if(typeof dashboard !== "undefined"){
        return true
      }
    })

    commit('SET_DASHBOARD_WIDGET', dashboardWidgets)
  }
}

const mutations = {
  setWidgetMenu(state, menus) {
    //state.menusWidgets.children = menus
    
    //console.log(menus);
  },
  setActiveMenuGroupHandler(state, router) {

    // const fullPath = router.history.current.fullPath

    // for (const category in state.menus) {
    //   if (state.menus[category].path == fullPath) {
    //     state.menus[category].active = true
    //   } else {
    //     state.menus[category].active = false
    //   }

    // }
  },

  setActiveMenuGroupHandler1(state, router) {
    const fullPath = router.history.current.fullPath
    const currentPathMatched = router.history.current.matched
    const path = fullPath.split('/')
    const matchedPath = '/' + path[2] + '/' + path[3]

    for (const category in state.menus) {
      // level 1
      if (state.menus[category].path == fullPath || state.menus[category].path == currentPathMatched[category]) {
        state.menus[category].active = true
      } else {
        state.menus[category].active = false
      }

      if (state.menus[category].items !== null) {

        // level 2
        for (const matched in state.menus[category].items) {
          if (state.menus[category].items[matched].path == fullPath) {
            state.menus[category].items[matched].active = true
          } else {
            state.menus[category].items[matched].active = false
          }

          // level 3                  
          if (state.menus[category].items[matched].items_widget !== null) {
            for (const widget in state.menus[category].items[matched].items_widget) {
              if (state.menus[category].items[matched].items_widget[widget].path == fullPath) {
                state.menus[category].active = true
                state.menus[category].items[matched].active = true
                state.menus[category].items[matched].items_widget[widget].active = true
              } else {
                state.menus[category].active = false
                state.menus[category].items[matched].active = false
                state.menus[category].items[matched].items_widget[widget].active = false
              }
            }
          }

        }
      }
    }
  },
  SET_DASHBOARD_WIDGET(state, payload) {
    for (var i = payload.length -1; i >= 0; i--){
      state.menusDashboard.splice(payload[i],1);
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}